import { useEffect, useRef, useState } from 'react';

/** Eases a displayed number towards `value` so a child sees it move rather than jump. */
export default function useCountUp(value, duration = 700) {
  const [shown, setShown] = useState(value);
  const raf = useRef(null);
  const from = useRef(value);

  useEffect(() => {
    if (raf.current) cancelAnimationFrame(raf.current);
    const start = performance.now();
    const begin = from.current;
    const to = value;
    if (begin === to) return undefined;
    const step = (t) => {
      const p = Math.min(1, (t - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      const next = Math.round(begin + (to - begin) * eased);
      from.current = next;
      setShown(next);
      if (p < 1) raf.current = requestAnimationFrame(step);
    };
    raf.current = requestAnimationFrame(step);
    return () => raf.current && cancelAnimationFrame(raf.current);
  }, [value, duration]);

  return shown;
}
